import { render, staticRenderFns } from "./pageCourseVideo.vue?vue&type=template&id=272cb761&scoped=true&"
import script from "./pageCourseVideo.vue?vue&type=script&lang=js&"
export * from "./pageCourseVideo.vue?vue&type=script&lang=js&"
import style0 from "./pageCourseVideo.vue?vue&type=style&index=0&id=272cb761&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "272cb761",
  null
  
)

export default component.exports